import React from 'react';
import {Link} from 'react-router-dom';
import {Requests, User} from 'api';
import {LoadingPage} from 'components/loading-page';
import {ShowIf} from 'components/utils';
import {NoContent} from 'components/no-content';
import ItemRequest from './ItemRequest.jsx';
import {connect} from 'react-redux';
import './_MyRequestContent.scss';

class MyRequestContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      count: 0,
      skip: 0,
      limit: 10,
      isLoading: false
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    this.setState({isLoading: true});
    User.actions.requestsCount.request({
      id: this.props.auth.user.id
    }).then((response) => {
      this.setState({count: response.data.count, isLoading: false});
      this.getList();
    }).catch((error) => {
      this.setState({isLoading: false});
    });
  }

  getList() {
    this.setState({isLoading: true});
    const params = {
      id: this.props.auth.user.id,
      filter: {
        include: 'product',
        order: 'createdAt DESC',
        limit: this.state.limit,
        skip: this.state.skip
      }
    };
    User.actions.requests.request(params).then(response => {
      let requests = this.state.data;
      response.data.map((item, idx) => {
        requests.push(item);
      });
      this.setState({data: requests, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  render() {
    const {isLoading, skip, limit, count} = this.state;
    return (
      <section className="list-request">
        <LoadingPage isShow={isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <div className='list-request-wrap'>
            {
              this.state.data.map((item, idx) => {
                return (
                  <ItemRequest key={idx} {...item}/>
                );
              })
            }
          </div>
        </ShowIf>
        <ShowIf condition={!isLoading && this.state.data.length == 0}>
          <NoContent content='Không có yêu cầu nào' height={724}/>
        </ShowIf>
        <ShowIf condition={!isLoading && this.state.data.length > 0 && (skip + limit) < count}>
          <div className="btn-see-more-wrap">
            <button className="btn-see-more" onClick={this.loadMore}>Xem Thêm</button>
          </div>
        </ShowIf>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps)(MyRequestContent);



// WEBPACK FOOTER //
// ./components/users/sub-view/my-request-content/MyRequestContent.jsx